import { useState as n } from "react";
function p() {
  const [o, e] = n(!1), { style: r } = document.documentElement;
  function s() {
    o ? t() : d();
  }
  function d() {
    r.setProperty("--drawer-border", "1px"), r.setProperty("--drawer-border-shift", "-35px"), e(!0);
  }
  function t() {
    r.setProperty("--drawer-border", "0px"), r.setProperty("--drawer-border-shift", "-30px"), e(!1);
  }
  return {
    toggleBorder: s,
    revertBorder: t
  };
}
export {
  p as u
};
